import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import insieme_a_te from '../../../assets/images/insieme_a_te.jpg'
import logoSenologiaRm1 from '../../../assets/images/logo-senologia-rm1.png'
import { useSelector } from "gf-ui";
import { TIPI_LAYOUT } from "../../../constants";

const HeaderSenologia = ({subtitle}) => {

  const tipoLayout = useSelector( state => state?.page?.data?.tipoLayout )

  return (    
    <section className="header senologia p-4">
      <Row>
        <Col xs={12} md={4} className="text-center text-md-start">
          { tipoLayout === TIPI_LAYOUT.PTV && (
            <Image src={`${process.env.REACT_APP_BASE_URL_PROD}stsInternet/images/layout/web/logoBreastUnit.jpg`} alt="logo" className="logo" />
          )}          
          { tipoLayout === TIPI_LAYOUT.RM1 && (
            <Image src={`${process.env.REACT_APP_BASE_URL_PROD}stsInternet/images/layout/web/logoEnte.jpg`} alt="logo" className="logo" />
          )}          
        </Col>
        <Col xs={12} md={8} className="col-header-title">
          { tipoLayout === TIPI_LAYOUT.PTV && (
            <>
              <img src={insieme_a_te} alt="logo" style={{ width: '100%', maxWidth: '400px'}} />
              <h4 className="text-center" style={{ color:'steelblue' }}>{subtitle}</h4>
            </>
          )}
          { tipoLayout === TIPI_LAYOUT.RM1 && (
            <img src={logoSenologiaRm1} alt="logo" style={{ width: '100%', maxWidth: '500px'}} />                          
          )}
        </Col>
      </Row>
    </section>
  )
}

export default HeaderSenologia;